import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import TokenApi from './api/TokenApi';

export const MODULE_ID = "malta_embedded_module";

export default class MaltaEmbeddedModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private apiCreated = false;
    private router!: VueRouter;
    private http!: HTTPClient;

    private tknApi!: TokenApi;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    menu: MenuItem[] = [];

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const TokenApi = (await import("./api/TokenApi")).default;
        this.tknApi = new TokenApi(http);
    }

    public get tokenApi(){
        return this.tknApi
    }
}
